import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../api/auth';

const Homework = () => {
  const { user } = useAuth();
  const [homework, setHomework] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHomework();
  }, []);

  const fetchHomework = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get('/parent/homework', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setHomework(response.data);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      pending: 'bg-yellow-100 text-yellow-700',
      done: 'bg-green-100 text-green-700',
      late: 'bg-red-100 text-red-700',
    };
    return badges[status] || 'bg-gray-100 text-gray-700';
  };

  const getStatusLabel = (status) => {
    const labels = {
      pending: 'À rendre',
      done: 'Rendu',
      late: 'En retard',
    };
    return labels[status] || status;
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-[#2C3E50]">📚 Devoirs</h1>
      <p className="text-gray-500">Consultez les devoirs de vos enfants</p>

      {loading ? (
        <div className="text-center py-8">Chargement...</div>
      ) : homework.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-8 text-center">
          <p className="text-gray-500">Aucun devoir</p>
        </div>
      ) : (
        <div className="space-y-4">
          {homework.map((hw) => (
            <div key={hw.id} className="bg-white rounded-xl shadow-md p-4 flex justify-between items-start">
              <div>
                <h3 className="font-semibold text-[#2C3E50]">{hw.title}</h3>
                <p className="text-sm text-gray-500">{hw.subject} - {hw.class_name}</p>
                <p className="text-sm text-gray-500">📅 {hw.due_date}</p>
                {hw.description && (
                  <p className="text-sm text-gray-600 mt-1">{hw.description}</p>
                )}
              </div>
              <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusBadge(hw.status)}`}>
                {getStatusLabel(hw.status)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Homework;